export default __webpack_public_path__ + "9276bfd.png";